import React, { useState } from "react";
import Section from "./Section";
import { X_PADDING } from "../constants";
import Page from "./Page";

const HealthInsurance = () => {
  return (
    <Page name="Health and Inurance">
      <div className="w-full pt-8 bg-white">
        {/*Careers */}
        <Section
          name="Insurance"
          description=" Learn about COAZ's efforts to promote equitable access to health insurance in Zambia through advocacy, awareness, and policy engagement aimed at improving healthcare coverage for all communities."
        />
      </div>
    </Page>
  );
};
export default HealthInsurance;
